import { calendarsService, dayTypesService } from "services";

export const getAllCalendars = (query) => async (dispatch) => {

	dispatch({
		type: 'LOADING'
	});

	try{
		const list = await calendarsService.getAll(query);

		dispatch({
			type: 'GET_CALENDARS',
			payload: list.data
		});
	}
	catch (error){
		console.log('Error: ' + error.message);
			dispatch({
				type: 'ERROR',
				payload: error.message
			});
	}
}

export const getSelectableCalendars = () => async (dispatch) => {

	dispatch({
		type: 'LOADING'
	});

	try{
		const list = await calendarsService.getSelectable();
		dispatch({
			type: 'GET_SELECT_CALENDARS',
			payload: list.data
		});
	}
	catch (error){
		console.log('Error: ' + error.message);
			dispatch({
				type: 'ERROR',
				payload: error.message
			});
	}
}

export const getWeekdaysDefault = () => async (dispatch) => {

	dispatch({
		type: 'LOADING'
	});

	try{
		const list = await calendarsService.getWeekdaysDefault();
		dispatch({
			type: 'GET_WEEKDAYS_DEFAULT',
			payload: list.weekdays
		});
	}
	catch (error){
		console.log('Error: ' + error.message);
			dispatch({
				type: 'ERROR',
				payload: error.message
			});
	}
}


export const getAllDayTypes = (query) => async (dispatch) => {

	dispatch({
		type: 'LOADING'
	});

	try{
		const list = await dayTypesService.getAll(query);

		dispatch({
			type: 'GET_DAY_TYPES',
			payload: list.data
		});
	}
	catch (error){
		console.log('Error: ' + error.message);
			dispatch({
				type: 'ERROR',
				payload: error.message
			});
	}
}


export const getSelectableDayTypes = () => async (dispatch) => {

	try{
		const list = await dayTypesService.getSelectable();

		dispatch({
			type: 'GET_SELECT_DAY_TYPES',
			payload: list.data
		});
	}
	catch (error){
		console.log('Error: ' + error.message);
			dispatch({
				type: 'ERROR',
				payload: error.message
			});
	}
}

export const getAllSystemCalendars = (query = '') => async (dispatch) => {
	dispatch({ type: 'LOADING_SYSTEM_CALENDARS' });

	try {
		const response = await calendarsService.getAllSystem();
		const calendars = Array.isArray(response) ? response : (response.data || []);
		const normalizedQuery = query.trim().toLowerCase();
		const filtered = normalizedQuery
			? calendars.filter((calendar) =>
				(calendar.name || '').toLowerCase().includes(normalizedQuery) ||
				(calendar.description || '').toLowerCase().includes(normalizedQuery)
			)
			: calendars;

		dispatch({ type: 'GET_SYSTEM_CALENDARS', payload: filtered });
	}
	catch (error) {
		dispatch({ type: 'ERROR_SYSTEM_CALENDARS', payload: error.message });
	}
}

export const getSystemDayTypes = () => async (dispatch) => {
	try {
		const response = await dayTypesService.getSystem();
		dispatch({
			type: 'GET_SYSTEM_DAY_TYPES',
			payload: Array.isArray(response) ? response : (response.data || [])
		});
	}
	catch (error) {
		dispatch({ type: 'ERROR_SYSTEM_CALENDARS', payload: error.message });
	}
}
